import {
  validSignedURL,
  validSignedURLWithExt,
} from "../../../utils/validateSignedUrl";

// SAP's PicturName (OITM) is the authoritative S3 label key and already carries the
// file extension. itemCode-based lookup stays as the fallback for shipment lines
// saved before picturName was captured.
export const imageKeyFor = (item: any) =>
  item?.picturName ||
  item?.factoryOrderDetail?.trackerOrder?.PicturName ||
  item?.factoryOrderDetail?.trackerOrder?.ItemCode ||
  item?.itemCode;

// PicturName keys already include the extension, so they resolve directly; itemCode
// keys need the .jpg/.png variants probed for them.
export const fetchSignedLabelURL = (
  key: string,
  setLoading: (e: boolean) => void,
  setImage: (e: string) => void,
) =>
  (/\.(jpe?g|png)$/i.test(key) ? validSignedURLWithExt : validSignedURL)(
    key,
    "label",
    setLoading,
    setImage,
  );
